import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SettingIcon = (props: SvgProps) => (
  <Svg

    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      stroke="#FDFBF9"
      d="M9.273 18h1.458l.357-2.32c.74-.16 1.352-.378 1.832-.65a5.44 5.44 0 0 0 1.365-1.134l2.223.87.766-1.279-1.755-1.457a7.021 7.021 0 0 0 .325-2.031c0-.637-.108-1.314-.325-2.029l1.755-1.457-.766-1.279-2.223.87c-.43-.504-.884-.887-1.365-1.15-.48-.262-1.091-.473-1.832-.634L10.73 2H9.273l-.357 2.32c-.74.16-1.351.378-1.832.651-.481.274-.936.651-1.365 1.133l-2.223-.87-.766 1.28L4.485 7.97a7.023 7.023 0 0 0-.325 2.032c0 .637.108 1.313.325 2.028L2.73 13.487l.766 1.28 2.223-.87c.43.481.884.859 1.365 1.132.48.273 1.091.49 1.832.652L9.273 18Zm.732-4.163c-1.061 0-1.967-.374-2.716-1.12-.749-.748-1.123-1.652-1.123-2.714 0-1.061.373-1.967 1.12-2.716.747-.749 1.652-1.123 2.713-1.123 1.062 0 1.967.373 2.716 1.12.749.747 1.124 1.652 1.124 2.713 0 1.062-.374 1.967-1.121 2.716-.747.75-1.651 1.124-2.713 1.124Z"
    />
    <Path
      fill="#000"
      d="M10.001 12a1.932 1.932 0 0 1-1.415-.584C8.196 11.026 8 10.555 8 10c0-.553.195-1.025.584-1.415.39-.39.861-.586 1.414-.586.554 0 1.026.195 1.416.584.39.39.586.861.586 1.414 0 .554-.195 1.026-.584 1.416-.39.39-.861.586-1.415.586Z"
    />
  </Svg>
)
export default SettingIcon
